import NepaliDate from 'nepali-date-converter';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Button, Col, FormControl, Row, Table } from 'react-bootstrap';
import { FaCoins, FaEye } from 'react-icons/fa';
import { fetchWrapper } from '../_helpers/fetchWrapper';
import { Link } from 'react-router-dom';
import PaginationComp from '../components/Pagination';
import { englishToNepaliNumber, englishToNepaliNumber as np } from 'nepali-number';
import { BsFillPeopleFill, BsDownload } from 'react-icons/bs';
import { RiStackFill } from 'react-icons/ri';
import { GiPapers } from 'react-icons/gi';
import { NepaliDatePicker } from 'nepali-datepicker-reactjs';
import 'nepali-datepicker-reactjs/dist/index.css';
import { VscLoading } from 'react-icons/vsc';
import moment from 'moment';

const Box = ({ title, icon = null, number }) => {
	return (
		<div className="dashboard-stats-box">
			<div className="dashboard-stats-box-content">
				<h5>{title}</h5>
			</div>
			<h5 className="dashboard-number">
				<kbd className="red-shade">{number}</kbd>
			</h5>
			<span>
				<div className="dashboard-stats-box-icon">{icon}</div>
			</span>
		</div>
	);
};

function Report({ fetchWards, fetchFiscalYear }) {
	const [isLoading, setIsLoading] = useState(false);
	const [papers, setPapers] = useState({});
	const [stats, setStats] = useState();

	const [page, setPage] = useState(1);
	const [downloadLoading, setDownloadLoading] = useState(false);
	const [filter, setFilter] = useState({
		// fy: activeFiscalYear?.id,
		ward: null,
		from: { ad: null, bs: null },
		to: { ad: null, bs: null },
	});
	const [toDateError, setToDateError] = useState(false);
	const [fromDateError, setFromDateError] = useState(false);

	const getPapers = useCallback(
		async (page) => {
			try {
				let uri = `/paper/?page=${page}`;
				if (filter.fy) {
					uri += `&fiscal_year=${filter.fy}`;
				}
				if (filter.ward) {
					uri += `&ward=${filter.ward}`;
				}
				if (filter.from.ad) {
					uri += `&from=${filter.from.ad}`;
				}
				if (filter.to.ad) {
					uri += `&to=${filter.to.ad}`;
				}
				setIsLoading(true);
				const res = await fetchWrapper.get(uri);
				setPapers(res.data);
				setIsLoading(false);
			} catch (error) {
				setIsLoading(false);
			}
		},
		[filter.fy, filter.ward, filter.from.ad, filter.to.ad]
	);

	const getData = useCallback(() => {
		let uri = `/report/stats/?page=${page}`;
		if (filter.fy) {
			uri += `&fiscal_year=${filter.fy}`;
		}
		if (filter.ward) {
			uri += `&ward=${filter.ward}`;
		}
		fetchWrapper
			.get(uri)
			.then((res) => setStats(res.data))
			.catch((err) => console.log(err));
	}, [page, filter.fy, filter.ward]);

	useEffect(() => {
		// fetchWards();
		// fetchFiscalYear();
	}, [fetchFiscalYear, fetchWards]);

	useEffect(() => {
		getPapers(page);
		getData();
	}, [filter.fy, getData, getPapers, filter.ward, page]);

	useEffect(() => {
		setPage(1);
	}, [filter.from.ad, filter.to.ad]);

	const handleDownloadFile = async (type = 'pdf') => {
		setDownloadLoading(true);
		let uri = `/report/list/?type=${type}`;
		if (filter.fy) {
			uri += `&fiscal_year=${filter.fy}`;
		}
		if (filter.ward) {
			uri += `&ward=${filter.ward}`;
		}
		const res = await fetchWrapper.get(uri);
		const a = document.createElement('a');
		a.href = res.data?.report;
		a.download = '';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		setDownloadLoading(false);
	};

	return (
		<Fragment>
			<Row className="justify-content-between">
				<Col md={4}>
					<FormControl as={'select'} onChange={(e) => setFilter({ ...filter, ward: e.target.value })}>
						{/* <option value="1">वडा कार्यालय छान्नुहोस्</option>
            {wards.map((w) => (
              <option value={w.id} key={w.id}>
                {w.name_np || w.name_en} न. वडा{" "}
              </option>
            ))} */}
					</FormControl>
				</Col>
				<Col md={4}>
					<FormControl as={'select'} onChange={(e) => setFilter({ ...filter, fy: e.target.value })}>
						<option value="1">आर्थिक वर्ष छान्नुहोस्</option>
						{/* {fiscalYear.map((fy) => (
              <option
                value={fy.id}
                key={fy.id}
                selected={activeFiscalYear.id === fy.id}
              >
                {fy.title}
              </option>
            ))} */}
					</FormControl>
				</Col>
			</Row>
			<Row className="mt-3 mb-5">
				<div className="col-3">
					<Box title="निवेदकहरु" number={np(stats?.applicant || 0)} icon={<BsFillPeopleFill />} />
				</div>
				<div className="col-3">
					<Link to="/templates/1">
						<Box title="सिफारिसका ढाँचा" number={np(stats?.templates || 0)} icon={<RiStackFill />} />
					</Link>
				</div>
				<div className="col-3">
					<Link to="/papers/verified/1">
						<Box title="जारी सिफारिस" number={np(stats?.papers || 0)} icon={<GiPapers />} />
					</Link>
				</div>
				<div className="col-3">
					<Box title="जम्मा रकम" number={`रु. ${np(stats?.worth || 0)} /-`} icon={<FaCoins />} />
				</div>
			</Row>
			<h4 className="mb-2 text-primary">जारी भएका सिफारिस</h4>
			<div className="d-flex justify-content-between align-items-center mb-2">
				<div className="d-flex">
					<div className="d-flex flex-column">
						<div className="d-flex align-items-center">
							<label htmlFor="from" className="w-100 mr-2 mb-0">
								From:{' '}
							</label>
							<NepaliDatePicker
								inputClassName="form-control"
								className=""
								value={filter.from.bs}
								onChange={(value) => {
									if (value && value !== filter.from.bs) {
										const Date = value.split('-');
										try {
											let { year, month, date } = new NepaliDate(
												parseInt(Date[0]),
												parseInt(Date[1]),
												parseInt(Date[2])
											).getAD();
											let today = moment().format('YYYY-MM-DD');
											let selectedAD = `${year}-${month}-${date}`;
											if (moment(selectedAD).isSameOrAfter(today, 'day') && filter.from.bs) {
												setFromDateError('चयन गरिएको मिति आजको मिति भन्दा ठूलो हुनु हुँदैन');
											} else {
												setFromDateError(false);
												setFilter({
													...filter,
													from: { ad: `${year}-${month}-${date}`, bs: value },
												});
											}
										} catch (error) {
											console.log(error);
										}
									}
								}}
								options={{ calenderLocale: 'ne', valueLocale: 'en' }}
							/>
						</div>
						<span className="p-2 text-danger">{fromDateError}</span>
					</div>

					<div className="d-flex flex-column">
						<div className="ml-4 d-flex align-items-center justify-content-start">
							<label className="w-100 mr-2 mb-0">To: </label>
							<NepaliDatePicker
								inputClassName="form-control"
								className=""
								value={filter.to.bs}
								onChange={(value) => {
									if (value && value !== filter.to.bs) {
										const Date = value.split('-');
										try {
											let { year, month, date } = new NepaliDate(
												parseInt(Date[0]),
												parseInt(Date[1]),
												parseInt(Date[2])
											).getAD();
											let today = moment().format('YYYY-MM-DD');
											let selectedAD = `${year}-${month}-${date}`;
											if (moment(selectedAD).isSameOrAfter(today, 'day')) {
												setToDateError('चयन गरिएको मिति आजको मिति भन्दा ठूलो हुनु हुँदैन');
											} else if (filter?.from?.ad) {
												if (moment(selectedAD).isSameOrAfter(filter?.from?.ad, 'day')) {
													setToDateError('चयन गरिएको मिति "From" मिति भन्दा सानो हुनु हुँदैन');
												}
											} else {
												setToDateError(false);
												setFilter({
													...filter,
													to: { ad: `${year}-${month}-${date}`, bs: value },
												});
											}
										} catch (error) {
											console.log(error);
										}
									}
								}}
								options={{ calenderLocale: 'ne', valueLocale: 'en' }}
							/>
						</div>
						<span className="p-2 text-danger">{toDateError}</span>
					</div>
				</div>
				<div>{papers?.count > 0 && <span>कुल संख्या: {englishToNepaliNumber(papers.count)}</span>}</div>
				<div className="">
					<Button variant="outline-primary" onClick={() => handleDownloadFile('excel')} disabled={downloadLoading}>
						<BsDownload />
						&nbsp;Excel
					</Button>
					<Button
						variant="outline-primary"
						className="ml-2"
						onClick={() => handleDownloadFile()}
						disabled={downloadLoading}
					>
						<BsDownload />
						&nbsp;PDF
					</Button>
				</div>
			</div>
			<Table size="sm" hover>
				<thead>
					<tr>
						<th>क्र.सं</th>
						<th>निबेदनको किसिम</th>
						<th>शिर्षक</th>
						<th>जारी मिति</th>
						<th>निवेदकको नाम</th>
						<th className="text-center">वडा</th>
						<th>
							<span className="d-block">दस्तुर</span>
							<span>रसिद नं.</span>
						</th>
						<th>कार्यहरु</th>
					</tr>
				</thead>
				<tbody>
					{isLoading ? (
						<tr>
							<td colSpan={10} className="text-center py-4">
								<VscLoading fontSize="34" className="spin" />
							</td>
						</tr>
					) : (
						papers?.results?.map((paper) => {
							let applicantName;
							// if (language === "english") {
							//   applicantName = paper.extra.fullname_en;
							// } else {
							//   applicantName = paper.extra.fullname_np;
							// }
							return (
								<tr key={paper.id}>
									<td>{paper.id}</td>
									<td>{paper.extra.paper_category} </td>
									<td>{paper.extra.paper_title} </td>
									<td>{new NepaliDate(new Date(paper.extra.created_at)).format('YYYY/MM/DD', 'np')}</td>
									<td>{applicantName || ''}</td>
									<td className="text-center">{paper.extra.ward}</td>
									<td>
										<span className="d-block">Rs. {paper.extra.charge}</span>
										<span>{paper?.invoice_detail?.invoice_no}</span>
									</td>
									<td>
										<Link to={`/paper-single/${paper?.id}`} className="btn btn-primary mx-1" title="अधिक जानकारी">
											<FaEye />
										</Link>
									</td>
								</tr>
							);
						})
					)}
				</tbody>
			</Table>
			{papers?.count > 10 && <PaginationComp total={papers.count} page={page} setPage={setPage} />}
		</Fragment>
	);
}

export default Report;
